import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";
import { AuthService } from "./auth/auth-service";

@inject(AuthService)
export class HttpClientService {
  private httpClient: HttpClient;

  constructor(authService: AuthService) {
    this.httpClient = new HttpClient().configure((h) => {
      h.withBaseUrl(HttpClientService.serviceBaseUrl);
      h.withTimeout(30000);
      h.withInterceptor(authService.getTokenInterceptor());
    });
  }

  get(): HttpClient {
    return this.httpClient;
  }

  static get basePath(): string {
    let baseURI = HttpClientService.baseURI;
    // get path from URL, see https://regex101.com/r/a6WB1a/1
    return /https?:\/\/([-a-zA-Z0-9@:%._\+~#=]{2,256}\b)*(\/[\/\d\w\.-]*)*(?:[\?])*(.+)*/gi.exec(
      baseURI,
    )![2];
  }

  static get serviceBaseUrl(): string {
    return (
      ((<any>window).isNodeDebuggingEnvironment
        ? "http://localhost:8080/kracht/"
        : HttpClientService.baseURI || "/") + "service"
    );
  }

  static get baseURI(): string {
    let baseURI = document.baseURI;
    if (baseURI) return baseURI;
    // fallback for IE11 which doesn't have document.baseURI:
    let baseTags = document.getElementsByTagName("base");
    if (baseTags && baseTags.length > 0) return baseTags[0].href;
    else return document.URL;
  }
}
